import { render } from "./WithTax.vue?vue&type=template&id=b883c6ae&scoped=true"
import script from "./WithTax.vue?vue&type=script&lang=js"
export * from "./WithTax.vue?vue&type=script&lang=js"

import "./WithTax.vue?vue&type=style&index=0&id=b883c6ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b883c6ae"]])

export default __exports__